// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vant from 'vant';
import {
  Dialog,
  Input,
  Form,
  Toast,
  Indicator,
  MessageBottom,
  MessageBox,
  Geste,
  // Request,
  // Env,
  // WxApi,
  Logger,
  SocketApi,
  ImRez,
  ReponeFont,
  Helper,
  ErrorHandler,
  Tabs,
  TabsItem,
  LoadMoreAnimation,
  // User,
  Dict,
  Svg,
  PickerOption,
  PickerMultiple,
  Collapse,
  TableV2,
  pageConfigV2
} from 'dby-base';
import { Request, Env, User } from '@duobaoyu/dby-base-mobile';
import { Swipe, SwipeItem } from 'mint-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import WxApi from '@/extend/wx2.js';
import compare from './helper/tool';
import App from '../../App';
import '@/style/common.scss';
import store from './store';
import pluginBase from '@/plugin/base';
import pluginAPI from '@/api/v2';
import mixins from '@/mixins';
import _helper from '@/extend/helper';
import Stat from '@/extend/stat.js';
import StatV2 from '@/extend/stat-v2.js';
import ExtendEnv from '@/extend/env';
import 'vant/lib/index.css';
import _native from './utils/native';
import OssUpload from '@/extend/ossUpload.js';

const routes = require('./router');

Vue.config.productionTip = false;
let app = {};
pluginBase({ app, store });
pluginAPI({ app, store });

Vue.use(Vant);
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper);
const router = new VueRouter({
  routes
});
Vue.use(Helper, _helper);
Vue.use(Env, {
  extend: ExtendEnv
});
if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$env.environment = 'prod';
}
Vue.use(Logger, {
  debug: (_APP_.ENABLE_CONSOLE ? 'openView' : 'close')
});
Vue.prototype.$compare = compare;
console.log('setHttpError', Request.setHttpError);
Vue.use(Request);
Vue.use(ErrorHandler);
Vue.use(SocketApi);
Vue.use(WxApi);
Vue.use(Geste);
Vue.use(ImRez);
Vue.use(Toast);
Vue.use(Stat, { app: '公众号' });
Vue.use(StatV2, {
  client_version: '1.0'
});
Vue.use(MessageBox);
Vue.use(Form);
Vue.use(User);
Vue.use(TableV2);
Vue.component(Svg.name, Svg);
Vue.use(Indicator);
Vue.use(pageConfigV2, router);
Vue.use(Dict, router);
Vue.component(MessageBottom.name, MessageBottom);
Vue.component(Input.name, Input);
Vue.component(Dialog.name, Dialog);
Vue.component(Tabs.name, Tabs);
Vue.component(TabsItem.name, TabsItem);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(LoadMoreAnimation.name, LoadMoreAnimation);
Vue.component(PickerOption.name, PickerOption);
Vue.component(PickerMultiple.name, PickerMultiple);
Vue.component(Collapse.name, Collapse);
Vue.mixin(mixins);
ReponeFont.init();
Vue.use(VueLazyload);
/* eslint-disable no-new */

Vue.use(OssUpload);

const context = {
  app,
  router,
  store: null,
  route: VueRouter.START_LOCATION,
  redirect(path) {
    router.replace(path);
    return false;
  },
  error(err) {
    if (_APP_.DEBUG) console.log(err);
    return false;
  }
};
_native(context);

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});
